import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FormContainer, FormInput, Treturn, useFetch } from "@4uhub/lib4uhub";
import {
  TTicketServiceWhatsForm,
  ticketServiceWhatsSchema,
} from "./TicketServiceWhatsSchema";
import { useParams } from "react-router-dom";
import { useCallback, useState } from "react";
import TicketServWhatsService from "../../../../../../services/ticketServiceWhats.service";
import WhatsappApiConfigs from "../../../../../../components/WhatsConfigData/WhatsappApiConfigs";
import { LoginButton } from "../TicketServiceForm/WhatsAppEmbeddedSignup/LoginButton";
import { WhatsappProfileModal } from "../../../../../../components/WhatsConfigData/WhatsappProfileModal/WhatsappProfileModal";
import { WhatsappNameModal } from "../../../../../../components/WhatsConfigData/WhatsappNameModal/WhatsappNameModal";

const ticketServiceWhats = new TicketServWhatsService();

const translationPath = "chatBot.page.register.ticketServiceWhats.";

const TicketServiceWhats = () => {
  const { t } = useTranslation();
  const { ticketServiceId } = useParams();
  const [verifyToken, setVerifyToken] = useState("");
  const [hasData, setHasData] = useState(false);

  const { sendRequest: save, loading: sLoading } = useFetch(
    ticketServiceWhats.create
  );
  const { sendRequest: update, loading: uLoading } = useFetch(
    ticketServiceWhats.updateItemById
  );
  const { sendRequest: get, loading: gLoading } = useFetch(
    ticketServiceWhats.getItemById
  );

  const handleSave = (v: TTicketServiceWhatsForm) => {
    return save({
      ...v,
      ticketServiceId: ticketServiceId || "",
    });
  };

  const updateHandler = (v: TTicketServiceWhatsForm, id: string) => {
    return update({
      item: {
        ...v,
        ticketServiceId: ticketServiceId || "",
      },
      id: id,
    });
  };

  const handleGet = useCallback(
    async (id: string): Promise<Treturn<TTicketServiceWhatsForm>> => {
      const { data, success } = await get(id);
      if (data) {
        if (data.whatsAppBusinessPhoneNumberId) setHasData(true);
        if (data.ticketService) {
          setVerifyToken(data.ticketService.verifyToken);
        }
        return {
          data: data,
          success: true,
        };
      }
      return { data, success };
    },
    [get]
  );

  const loading = sLoading || uLoading || gLoading;

  const [whatsappBusinesProfileModalOpen, setWhatsappBusinesProfileModalOpen] =
    useState(false);

  const closeWhatsappBusinesProfileModalHandler = useCallback(() => {
    setWhatsappBusinesProfileModalOpen(false);
  }, []);

  const openWhatsappBusinesProfileModalHandler = useCallback(async () => {
    setWhatsappBusinesProfileModalOpen(true);
  }, []);

  const [whatsappNameModalOpen, setWhatsappNameModalOpen] = useState(false);

  const closeWhatsappNameModalHandler = useCallback(() => {
    setWhatsappNameModalOpen(false);
  }, []);

  const openWhatsappNameModalHandler = useCallback(async () => {
    setWhatsappNameModalOpen(true);
  }, []);

  return (
    <>
      <WhatsappProfileModal
        open={whatsappBusinesProfileModalOpen}
        closeHandler={closeWhatsappBusinesProfileModalHandler}
      />
      <WhatsappNameModal
        open={whatsappNameModalOpen}
        closeHandler={closeWhatsappNameModalHandler}
      />
      <FormContainer<TTicketServiceWhatsForm>
        saveFunction={handleSave}
        updateFunction={updateHandler}
        getFunction={handleGet}
        loading={loading}
        title={t(translationPath + "ticket_service_whats")}
        schema={ticketServiceWhatsSchema}
        subtitle={t(translationPath + "new_ticket_service_whats")}
        subtitleWatchField={"whatsAppBusinessPhoneNumberId"}
        fields={() => (
          <>
            {verifyToken && (
              <Grid container mb={8}>
                <WhatsappApiConfigs
                  verifyToken={verifyToken}
                  openWhatsappBusinesProfileModalHandler={
                    openWhatsappBusinesProfileModalHandler
                  }
                  openWhatsappNameModalHandler={openWhatsappNameModalHandler}
                />
              </Grid>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormInput
                  size="small"
                  name="whatsAppBusinessPhoneNumberId"
                  fullWidth
                  label={
                    t(translationPath + "business_phone_number") ||
                    "Whatsapp Business Phone Number Id"
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormInput
                  size="small"
                  name="whatsAppBusinessAccountId"
                  fullWidth
                  label={
                    t(translationPath + "business_account") ||
                    "Whatsapp Business Account Id"
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormInput
                  size="small"
                  name="whatsAppBusinessId"
                  fullWidth
                  label={
                    t(translationPath + "whatsapp_business") ||
                    "Whatsapp Business Id"
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormInput
                  size="small"
                  name="accessToken"
                  fullWidth
                  label={t(translationPath + "access_token") || "Access Token"}
                />
              </Grid>
            </Grid>
            {!hasData && ticketServiceId && (
              <LoginButton id={ticketServiceId}></LoginButton>
            )}
          </>
        )}
      />
    </>
  );
};

export default TicketServiceWhats;
